/* eslint-disable camelcase */
import { trackPage, trackClick, trackPublisher } from ".";
import LevelsEnum from "./enums/levels";
import ClickTypes from "./enums/click-types";
import ChaptersEnum from "./enums/chapters";
import { Click, Publisher } from "../Interfaces/tracking";

const CROSS_SELL_PAGE = "cross-sell";
const CROSS_SELL_GROUPE_PAGE = "cross-sell-groupe";

// Pages tracking

export function trackPageCrossSell({ requestId }: { requestId?: string }) {
  return trackPage({
    page: CROSS_SELL_PAGE,
    page_chapter1: CROSS_SELL_PAGE,
    site_level2: LevelsEnum.MyAccount,
    requestId,
  });
}

export function trackPageCrossSellGroupe({ requestId }: { requestId?: string }) {
  return trackPage({
    page: CROSS_SELL_GROUPE_PAGE,
    page_chapter1: CROSS_SELL_GROUPE_PAGE,
    site_level2: LevelsEnum.MyAccount,
    requestId,
  });
}

// Publishers tracking

export function trackCrossSellPublisherImpression(params: {
  pageSlug: "cross-sell" | "cross-sell-groupe";
  family: string;
  subFamily: string;
  positionItem: number;
  nbItems: number;
  url?: string;
  contentId?: string;
}): Publisher {
  const { pageSlug, family, subFamily, positionItem, nbItems, url = "" } = params;
  const generalPlacement =
    nbItems > 1 ? `[${positionItem + 1}-${nbItems}]` : `[${positionItem + 1}]`;
  return trackPublisher("publisher.impression", {
    onsitead_campaign: `[${pageSlug}::::${pageSlug}]`,
    onsitead_creation: `[${url || "no_url"}]`,
    onsitead_variant: `[${subFamily}]`,
    onsitead_format: `[${family}]`,
    onsitead_general_placement: generalPlacement,
    onsitead_detailed_placement: "",
    onsitead_advertiser: `[${family}]`,
    onsitead_url: url,
  });
}

// Clicks tracking

export function trackClickCrossSellLater({ requestId }: { requestId?: string }) {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: "later",
    click_chapter1: ChaptersEnum.MyAccount,
    click_chapter2: CROSS_SELL_PAGE,
    site_level2: LevelsEnum.MyAccount,
    requestId,
  });
}

export function trackClickCrossSellBack({ requestId }: { requestId?: string }) {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: "back",
    click_chapter1: ChaptersEnum.MyAccount,
    click_chapter2: CROSS_SELL_GROUPE_PAGE,
    site_level2: LevelsEnum.MyAccount,
    requestId,
  });
}

export function trackClickCrossSellCCS({
  family,
  subFamily,
}: {
  family: string;
  subFamily: string;
  requestId?: string;
  contentId?: string;
}) {
  trackPublisher("publisher.click", {
    onsitead_campaign: "[cross-sell::::cross-sell]",
    onsitead_creation: "[no_url]",
    onsitead_variant: `[${subFamily}]`,
    onsitead_format: `[${family}]`,
    onsitead_general_placement: "",
    onsitead_detailed_placement: "",
    onsitead_advertiser: `[${family}]`,
    onsitead_url: "",
  });
}

export function trackClickCrossSellGCCS({ requestId }: { requestId?: string }): Click {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: "click.gccs",
    click_chapter1: ChaptersEnum.MyAccount,
    click_chapter2: CROSS_SELL_PAGE,
    site_level2: LevelsEnum.MyAccount,
    requestId,
  });
}

export function trackClickCrossSellGroupeCCS({
  family,
  subFamily,
}: {
  family: string;
  subFamily: string;
  requestId?: string;
  contentId?: string;
}) {
  trackPublisher("publisher.click", {
    onsitead_campaign: `[${CROSS_SELL_GROUPE_PAGE}::::${CROSS_SELL_GROUPE_PAGE}]`,
    onsitead_creation: "[no_url]",
    onsitead_variant: `[${subFamily}]`,
    onsitead_format: `[${family}]`,
    onsitead_general_placement: "",
    onsitead_detailed_placement: "",
    onsitead_advertiser: `[${family}]`,
    onsitead_url: "",
  });
}
